import { render, staticRenderFns } from "./ChatFooter.vue?vue&type=template&id=5e239478&scoped=true"
import script from "./ChatFooter.vue?vue&type=script&lang=js"
export * from "./ChatFooter.vue?vue&type=script&lang=js"
import style0 from "./ChatFooter.vue?vue&type=style&index=0&id=5e239478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e239478",
  null
  
)

export default component.exports